export const parseValueToOnlyDigits = (value: unknown) => {
  if (typeof value === 'string') {
    return value.replace(/\D/g, '');
  }
  return value;
};
